const normalizeNumber = value => {
  if (value == null || value === '') {
    return null;
  }
  const number = typeof value === 'number' ? value : Number.parseFloat(String(value).trim());
  return Number.isFinite(number) ? number : null;
};

export const getListingReviewSummary = listing => {
  const publicData = listing?.attributes?.publicData || listing?.publicData || {};
  const rating = normalizeNumber(publicData.averageRating);
  const count = normalizeNumber(publicData.totalReviews);
  const averageRating = rating > 0 && rating <= 5 ? rating : 0;
  const reviewCount = count > 0 ? Math.floor(count) : 0;

  return averageRating > 0 && reviewCount > 0 ? { averageRating, reviewCount } : null;
};
